module.exports = __webpack_public_path__ + "img/783.48cd6856.jpg";